module.exports = __webpack_public_path__ + "media/icons/2@3x-9e18aa4f.svg";